import { useEffect, useState } from "react"
import { useContext } from "react";
import { GlobalStates } from "../GlobalStates";
import PrimaryTextField from "../Components/PrimaryTextField/PrimaryTextField"
import { useTranslation } from "react-i18next";
import PrimaryButton from "../Components/Button/PrimaryButton";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Validate } from "../functionsIsmesti/validation";
import { t } from 'i18next';
import { useUser } from "../Hooks";

const Profile = (props) => {

    const { t } = useTranslation()
    const { user, setUser, path, setAlert } = useContext(GlobalStates)
    const [disabled, setDisabled] = useState(true)

    const [r, setR] = useState(0)
    const { updateUser } = useUser();
    
    // Atsinaujinus duomenims iš duomenų bazės, suskaldome vardas pavardė į atskirus laukus
    useEffect(() => {
        // Jei yra vardas ir pavardė, bet nėra VP (arba jis tuščias)
        if ((user.vardas || user.pavarde) && !user.VP) {
            user.VP = `${user.vardas || ''} ${user.pavarde || ''}`.trim();
            setR(r + 1);
        }
    }, [user.vardas, user.pavarde]);
    
    useEffect(() => {
        try {
            setDisabled(true)
            
            // Tikrinama ar vardas ir pavardė įvesti teisingai
            if (!Validate(user.vardas, 'name') || !Validate(user.pavarde, 'name')) {
                throw false
            }
            
            // Tikrinama ar telefono numeris įvestas teisingai
            if (!Validate(user.tel, 'numberValidation')) {
                throw false
            }
            
            setDisabled(false)
        } catch (error) {
            // Klaidos atveju mygtukas lieka išjungtas
        }
    }, [r])

    return (
        <div className="profilisCont">
            <div className="fakeModal column">
                <h2 className="text-xl font-bold mb-4">{t('profilio_redagavimas')}</h2>
                <div className="profilioImonesMargin">
                    <PrimaryTextField
                        label='login_email'
                        defaultValue={user.email}
                        fullWidth={true}
                        size='small'
                        classNameForm='biggerTxtMargin'
                        disabled={true}
                        autoComplete="new-password"
                    />
                    <PrimaryTextField
                        label='imones_pav'
                        defaultValue={user.imonesPavadinimas}
                        fullWidth={true}
                        size='small'
                        classNameForm='biggerTxtMargin'
                        disabled={true}
                        autoComplete="new-password"
                    />
                    <div className="grid grid-cols-2 gap-4 mb-4">
                        <PrimaryTextField
                            label='vardas'
                            defaultValue={user.vardas}
                            onChange={(e) => { 
                                user.vardas = e; 
                                user.VP = `${e} ${user.pavarde || ''}`.trim();
                                setR(r + 1); 
                            }}
                            fullWidth={true}
                            size='small'
                            classNameForm='biggerTxtMargin'
                            validate='name'
                            autoComplete="new-password"
                            errorMsg={t('ivestiVarda')}
                        />
                        <PrimaryTextField
                            label='pavarde'
                            defaultValue={user.pavarde}
                            onChange={(e) => { 
                                user.pavarde = e; 
                                user.VP = `${user.vardas || ''} ${e}`.trim();
                                setR(r + 1); 
                            }}
                            fullWidth={true}
                            size='small'
                            classNameForm='biggerTxtMargin'
                            validate='name'
                            autoComplete="new-password"
                            errorMsg={t('ivestiPavarde')}
                        />
                    </div>
                    <PrimaryTextField
                        label='telNr'
                        defaultValue={user.tel}
                        onChange={(e) => { user.tel = e; setR(r + 1) }}
                        fullWidth={true}
                        size='small'
                        classNameForm='biggerTxtMargin mb-6'
                        validate='numberValidation'
                        autoComplete="new-password"
                        errorMsg={t('neteisingasTel')}
                    />
                </div>
                <div className="mt-10 mb-6">
                    <PrimaryButton
                        text={'issaugoti'}
                        onClick={async () => {
                            try {
                                // Išskleidžiame VP į vardas ir pavarde prieš išsaugant
                                if (user.VP && (!user.vardas || !user.pavarde)) {
                                    const nameParts = user.VP.split(' ');
                                    if (nameParts.length > 1) {
                                        user.vardas = nameParts[0];
                                        user.pavarde = nameParts.slice(1).join(' ');
                                    } else {
                                        user.vardas = user.VP;
                                        user.pavarde = '';
                                    }
                                }
                                
                                // Sukuriame kopiją ir pašaliname VP lauką, kurio nėra duomenų bazėje
                                const userToUpdate = { ...user };
                                delete userToUpdate.VP; // Pašaliname VP lauką, nes jo nėra DB
                                
                                // Atnaujiname naudotoją
                                const result = await updateUser(user.id, userToUpdate, setUser);
                                
                                if (result) {
                                    // Jei pavyko, atnaujinkime UI
                                    setR(r + 1);
                                    
                                    // Rodome sėkmės pranešimą
                                    setAlert(t('profilis_atnaujintas'));
                                    
                                    // Nukreipimas į pagrindinį puslapį po sėkmingo atnaujinimo
                                    setTimeout(() => {
                                        window.location.href = '/';
                                    }, 2000);
                                } else {
                                    // Jei nepavyko, rodome klaidą
                                    setAlert(t('klaida'));
                                }
                            } catch (error) {
                                console.error('Profilio atnaujinimo klaida:', error);
                                setAlert(t('klaida'));
                            }
                        }}
                        className='width100'
                        endIcon={<ArrowForwardIcon />}
                        disabled={disabled}
                    />
                </div>
            </div>
        </div>
    )
}
export default Profile